export default __webpack_public_path__ + "static/media/Top.73eef499.dwg";